import { getValue } from "@utils/lodash";
import "./comments-section.scss";

export default function Comments(props: any) {
  return (
    <section className="add-comments-wrapper">
      <div className="add-comments-wrapper__form-group form-group d-flex align-items-center">
        {/* <label className="add-comments-wrapper__label">
          <h6>S</h6>
        </label> */}
        <textarea
          rows={3}
          className="w-100 add-comments-wrapper__textarea"
          value={getValue(props, `request.comments`, "")}
          placeholder="Add a comment"
          name="comments"
          onChange={props.handleChange}
        />
      </div>
      <div className="add-comments-wrapper__cta-wrapper d-flex">
        <button
          className="user-details-wrapper__cta-btn user-details-wrapper__cta-btn--primary mx-3"
          onClick={() => props.handleChange("")}
        >
          Cancel
        </button>
        {getValue(props, `permissions`, []).includes("update") && (
          <button
            className="user-details-wrapper__cta-btn user-details-wrapper__cta-btn--secondary"
            onClick={props.handleSubmit}
          >
            {props.isLoading
              ? "Please wait..."
              : getValue(props, `editId`, "")
              ? "Update"
              : "Comment"}
          </button>
        )}
      </div>
    </section>
  );
}
